/* ==========================================================================
   Supplement tabs — pill switcher + cross-section "show composition" event
   ========================================================================== */
(function () {
  'use strict';

  function initTabs(root) {
    if (root.dataset.supReady) return;
    root.dataset.supReady = '1';

    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-sup-tab]'));
    var panes = Array.prototype.slice.call(root.querySelectorAll('[data-sup-pane]'));

    function activate(tabId, focus) {
      pills.forEach(function (p) {
        var on = p.dataset.supTab === tabId;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && focus) p.focus();
      });
      panes.forEach(function (pane) {
        pane.hidden = pane.dataset.supPane !== tabId;
      });
    }

    pills.forEach(function (pill, i) {
      pill.addEventListener('click', function () { activate(pill.dataset.supTab); });
      pill.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = pills[(i + dir + pills.length) % pills.length];
        activate(next.dataset.supTab, true);
      });
    });

    /* Open a pane by its pane-type (used by the ingredients "Voir la composition" CTA) */
    function showByPaneType(type) {
      var pane = panes.filter(function (p) { return p.dataset.paneType === type; })[0];
      if (!pane) return;
      activate(pane.dataset.supPane);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { root.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
      catch (e) { root.scrollIntoView(); }
    }
    document.addEventListener('sup:show-tab', function (e) {
      if (e.detail && e.detail.pane) showByPaneType(e.detail.pane);
    });
  }

  function boot() {
    document.querySelectorAll('[id^="supplement-tabs-"]').forEach(initTabs);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
